<template>
  <div>
    <div style="background: #f8dc54; height: 20px">
      <v-spacer />
    </div>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <div><v-img src="@/assets/image/logo.png" class="logo-img" /></div>
      </v-row>
      <v-row align="center" justify="center">
        <v-col>
          <div class="box-maintenance">
            <div class="title-maintenance">
              {{ $t('common.warning_maintenance_title') }}
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col>
          <div class="box-maintenance">
            <div class="content-maintenance">
              {{ $t('common.warning_maintenance1') }}
              <br />
              {{ $t('common.warning_maintenance2') }}
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col>
          <div class="box-maintenance">
            <div class="content-maintenance">
              {{ $t('common.warning_maintenance_footer') }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  mounted() {
    this.check();
  },
  methods: {
    check() {
      const flag = localStorage.getItem('notify_maintenance');
      if (flag === 'false' || !flag) {
        this.$router.push('/');
      }
    },
  },
};
</script>

<style>
.logo-img {
  max-width: 180px;
  margin-top: 50px;
}
.box-maintenance {
  margin-top: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}
.title-maintenance {
  font-size: 25px !important;
}
.content-maintenance {
  font-size: 20px !important;
}
.img-margin {
  margin-left: 10px;
}
</style>
